import React from "react";
import { TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { ProductDistributor, productDistributors } from "../../api/specialDisplays";

interface Props {
  type: ProductDistributor | null;
  setType: (value: ProductDistributor | null) => void;
  required?: boolean;
  small?: boolean;
}
export const ProductDistributorSelect = ({ type, setType, required = false, small = false }: Props): JSX.Element => {
  return (
    <Autocomplete
      id="productDistributor"
      options={productDistributors}
      getOptionLabel={(option) => option.name}
      onChange={(_, value) => setType(value)}
      value={type}
      renderInput={(props) => <TextField {...props} variant="outlined" label="Varasto" required={required} />}
      fullWidth
      size={small ? "small" : "medium"}
    />
  );
};
